var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right-body", attrs: { id: "imageSaverVideo" } },
    [
      _c(
        "div",
        { staticClass: "imagesaver_content" },
        [
          _c(
            "div",
            {
              staticClass: "url_content",
              class: _vm.isShowInit ? "url_content_init" : ""
            },
            [
              _c("el-input", {
                ref: "videlInputEle",
                staticClass: "url_input",
                attrs: {
                  type: "input",
                  placeholder: _vm.inputFocus
                    ? ""
                    : _vm.$t("language.imageSaver.videoInputTip")
                },
                on: {
                  input: _vm.limitRowsUrls,
                  focus: function($event) {
                    _vm.inputFocus = true
                  },
                  blur: function($event) {
                    _vm.inputFocus = false
                  }
                },
                nativeOn: {
                  paste: function($event) {
                    return _vm.pastedUrl($event)
                  }
                },
                model: {
                  value: _vm.urls,
                  callback: function($$v) {
                    _vm.urls = $$v
                  },
                  expression: "urls"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "url_button",
                  attrs: {
                    type: "primary",
                    disabled: _vm.urls == "",
                    loading: _vm.encodeing
                  },
                  on: { click: _vm.clickDeCodeBtn }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.encodeing
                        ? _vm.$t("language.imageSaver.analyzing")
                        : _vm.$t("language.imageSaver.download")
                    )
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("imageSaverPath", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.node && !_vm.isShowInit,
                expression: "node&&!isShowInit"
              }
            ],
            attrs: {
              node: _vm.node,
              updateTaskDestDrive: _vm.updateTaskDestDrive,
              loadDestNode: _vm.loadDestNode
            }
          }),
          _vm._v(" "),
          !_vm.isShowInit
            ? _c("div", { staticClass: "imagesaver_video_view" }, [
                _vm.title && _vm.title.fullTitle
                  ? _c("div", { staticClass: "imagesaver_video_header" }, [
                      _c(
                        "div",
                        { staticClass: "imagesaver_video_header_cover" },
                        [
                          _c(
                            "el-image",
                            {
                              attrs: {
                                src: _vm.title.thumbnailUrl,
                                fit: "contain"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "image-slot",
                                  attrs: { slot: "error" },
                                  slot: "error"
                                },
                                [_c("i", { staticClass: "picture-outline" })]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "imagesaver_video_header_title" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "imagesaver_video_header_txt",
                              attrs: { title: _vm.title.fullTitle }
                            },
                            [_vm._v(_vm._s(_vm.title.fullTitle))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "imagesaver_video_header_items" },
                            [
                              _vm.title.publisher
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "imagesaver_video_header_item"
                                    },
                                    [
                                      _vm.title.avatar
                                        ? _c("img", {
                                            attrs: { src: _vm.title.avatar }
                                          })
                                        : _c("img", {
                                            attrs: {
                                              src: require("../../assets/images/vectorImg/icon_User.svg")
                                            }
                                          }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.title.publisher))
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "imagesaver_video_header_item" },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      padding: "5px",
                                      width: "20px",
                                      height: "20px"
                                    },
                                    attrs: {
                                      src: require("../../assets/images/vectorImg/date.svg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(_vm.title.date))])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.datas && _vm.datas.length > 0
                  ? _c(
                      "div",
                      { staticClass: "imagesaver_video_list table-list-1" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              id: "imagesaverVideoView",
                              data: _vm.datas,
                              stripe: "",
                              "tooltip-effect": "dark",
                              "max-height": "100%",
                              height: "100%"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: { label: "Format", width: "335" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "table-cell" },
                                          [
                                            _c("div", {
                                              staticClass: "file-type",
                                              class: _vm.matchfileType(
                                                scope.row.category
                                              )
                                            }),
                                            _vm._v(" "),
                                            scope.row.category != "thumbnail"
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.toUpperCase(
                                                        scope.row.ext
                                                      )
                                                    )
                                                  )
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.imageSaver.thumbnail"
                                                      )
                                                    )
                                                  )
                                                ])
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2232624578
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "Quality", width: "420" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.category == "Video"
                                          ? _c(
                                              "div",
                                              { staticClass: "table-cell" },
                                              [
                                                scope.row.quality
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getQualityTxt(
                                                            scope.row.quality
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                scope.row.quality &&
                                                scope.row.fps
                                                  ? _c("span", [
                                                      _vm._v(_vm._s(" · "))
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                scope.row.fps
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.fps + " FPS"
                                                        )
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !scope.row.quality &&
                                                !scope.row.fps
                                                  ? _c("span", [
                                                      _vm._v(_vm._s(" -- "))
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                scope.row.formatId ==
                                                _vm.title.bestVideoId
                                                  ? _c("div", {
                                                      staticClass:
                                                        "best-flag-video"
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.category == "Audio"
                                          ? _c(
                                              "div",
                                              { staticClass: "table-cell" },
                                              [
                                                scope.row.abr
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.imageSaver." +
                                                              _vm.getAbtTxt(
                                                                scope.row.abr
                                                              )
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : _c("span", [_vm._v("--")]),
                                                _vm._v(" "),
                                                scope.row.formatId ==
                                                _vm.title.bestAudioId
                                                  ? _c("div", {
                                                      staticClass:
                                                        "best-flag-audio"
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.category == "thumbnail"
                                          ? _c(
                                              "div",
                                              { staticClass: "table-cell" },
                                              [
                                                scope.row.resolution
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.resolution
                                                        )
                                                      )
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.imageSaver.default"
                                                          )
                                                        )
                                                      )
                                                    ])
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3015257029
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "table-cell" },
                                          [
                                            scope.row.synthesizing
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "video-synthesizing"
                                                  },
                                                  [
                                                    _c("i"),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.imageSaver.process"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "list-btns" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "list-btn",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.saveToCloud(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "save-to-cloud"
                                                        }),
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "language.imageSaver.saveToCloud"
                                                              )
                                                            ) +
                                                            "\n                                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "list-btn",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.download(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "download"
                                                        }),
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "language.imageSaver.download"
                                                              )
                                                            ) +
                                                            "\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1981353586
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c("div", { staticClass: "imagesaver_video_error" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../assets/images/imageSaver/imageNo.svg")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "imagesaver_video_error_text" },
                        [_vm._v(_vm._s(_vm.$t("language.imageSaver.noImage")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "imagesaver_video_error_dest" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("language.imageSaver.notSupport"))
                          )
                        ]
                      )
                    ])
              ])
            : _c("div", { staticClass: "imagesaver_video_default" }, [
                _c("div", {
                  staticClass: "imagesaver_video_default_tips",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("language.imageSaver.videoTip"))
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "imagesaver_video_default_sites" },
                  _vm._l(_vm.sites, function(site, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "imagesaver_video_default_site",
                        on: {
                          click: function($event) {
                            return _vm.jumpToSite(site.url)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/images/sitesLogo/" +
                              site.name +
                              ".png")
                          }
                        }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(site.name) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "img-buttom" }),
      _vm._v(" "),
      _c("transferAimsDialog", { ref: "transferAimsDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d66a7f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d66a7f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/video_saver.vue
// module id = null
// module chunks = 